// @flow
import moment from 'moment';

import fetch from 'utils/fetch';
import { serializeFeature } from 'utils/geometry';
import { formatMinutesAsTime } from 'utils/datetime';

import { resetState as contactCardResetState } from 'actions/contactCard';
import { setSearchData } from 'actions/search';

export const SEARCH_RESULTS_DIALOG_SET_ERROR = 'searchResultsDialog/SET_ERROR';
export const SEARCH_RESULTS_DIALOG_TOGGLE = 'searchResultsDialog/TOGGLE';
export const SEARCH_RESULTS_DIALOG_TOGGLE_WAITING =
  'searchResultsDialog/TOGGLE_WAITING';
export const SEARCH_RESULTS_DIALOG_SET_GEOMETRY_FORMAT =
  'searchResultsDialog/SET_GEOMETRY_FORMAT';

export function toggleSearchResultsDialog(visible) {
  return dispatch => {
    if (visible) {
      dispatch(setError(false));
      dispatch(contactCardResetState());
    }

    dispatch({
      type: SEARCH_RESULTS_DIALOG_TOGGLE,
      visible,
    });
  };
}

export function setError(error) {
  return {
    type: SEARCH_RESULTS_DIALOG_SET_ERROR,
    error,
  };
}

export function setGeometryFormat(geometryFormat) {
  return {
    type: SEARCH_RESULTS_DIALOG_SET_GEOMETRY_FORMAT,
    geometryFormat,
  };
}

export function toggleWaiting(waiting) {
  return {
    type: SEARCH_RESULTS_DIALOG_TOGGLE_WAITING,
    waiting,
  };
}

export function requestAnalysis() {
  return async (dispatch, getState) => {
    const {
      drawOverlay: { feature },
      filters: { dateRange, timeRange, altitudeRange, airspaceUseType, isSRSS },
    } = getState();

    dispatch(toggleWaiting(true));
    dispatch(toggleSearchResultsDialog(true));

    try {
      const response = await fetch('/api/v1/s/store', {
        method: 'POST',
        body: JSON.stringify({
          dateRange: {
            min: moment(dateRange.min).unix(),
            max: moment(dateRange.max).unix(),
          },
          timeRange: {
            min: formatMinutesAsTime(false)(timeRange.min),
            max: formatMinutesAsTime(false)(timeRange.max),
          },
          isSRSS,
          altitudeRange,
          geometry: feature.geometry,
          geometry_text: await serializeFeature(feature),
          useType: airspaceUseType,
        }),
      });

      dispatch(setSearchData(await response.json()));
    } catch (e) {
      dispatch(setError(true));
    } finally {
      dispatch(toggleWaiting(false));
    }
  };
}



// WEBPACK FOOTER //
// ./actions/searchResultsDialog.js